var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _path2, _path3, _circle8, _circle9, _circle0, _circle1, _circle10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarlinkPlanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.125,
    r: 4.625,
    stroke: "black",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.125,
    r: 4.625,
    stroke: "black",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8.25,
    r: 5.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8.25,
    r: 5.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 14,
    r: 0.75,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 14,
    r: 0.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 14,
    r: 0.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25003 2.5C8.25003 2.91421 7.91424 3.25 7.50003 3.25C7.08582 3.25 6.75003 2.91421 6.75003 2.5C6.75003 2.08579 7.08582 1.75 7.50003 1.75C7.91424 1.75 8.25003 2.08579 8.25003 2.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25003 2.5C8.25003 2.91421 7.91424 3.25 7.50003 3.25C7.08582 3.25 6.75003 2.91421 6.75003 2.5C6.75003 2.08579 7.08582 1.75 7.50003 1.75C7.91424 1.75 8.25003 2.08579 8.25003 2.5Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25003 2.5C8.25003 2.91421 7.91424 3.25 7.50003 3.25C7.08582 3.25 6.75003 2.91421 6.75003 2.5C6.75003 2.08579 7.08582 1.75 7.50003 1.75C7.91424 1.75 8.25003 2.08579 8.25003 2.5Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 1.25,
    fill: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 1.25,
    stroke: "black",
    strokeWidth: 0.5
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 1.25,
    stroke: "black",
    strokeWidth: 0.5
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.125,
    r: 6.875,
    stroke: "black",
    strokeWidth: 0.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.125,
    r: 6.875,
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarlinkPlanIcon);
export default __webpack_public_path__ + "static/media/StarlinkPlanIcon.2a4642edb901888f3607e954c4adc56c.svg";
export { ForwardRef as ReactComponent };